import { Component } from 'react';
import React from 'react';

import Select from '../../Helpers/react-select-all';
import DatePicker from 'react-datepicker';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {filterByValuesMessages} from '../../../Helpers/HelperFunctions'
import {addReport} from '../../../redux/actions/reportAction';
import { setSnackbarMessage } from '../../../redux/actions/snackbarAction';

class ReportGenerator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            address : false,
            currentTab: 'address_data',
            reportType: false,
            reportTypes: [],
            reportTypeMetaCategories: false,
            selectedAddresses: false,
            attached_values: false,
            user: this.props.user,
            repetitive: [{value: '', label: 'Eenmalig'},
                         {value: 'YEARLY', label: 'Jaarlijks'},
                         {value: 'SIX_MONTHLY', label: 'Elke 6 maanden'},
                         {value: 'THREE_MONTHLY', label: 'Elke 3 maanden'},
                         {value: 'MONTHLY', label: 'Maandelijks'},
                         {value: 'TWO_WEEKLY', label: 'Twee wekelijks'},
                         {value: 'WEEKLY', label: 'Wekelijks'}
                        ]
        }

        this.reportTypeSelected = this.reportTypeSelected.bind(this);
        this.mapMetaCategories = this.mapMetaCategories.bind(this);
        this._getAddressesForReportTypes = this._getAddressesForReportTypes.bind(this);
        this.addressSelected = this.addressSelected.bind(this);
        this._setSelectedRepetitive = this._setSelectedRepetitive.bind(this);

    }
    componentDidMount() {
        let reportTypes = [];
        const types = this.props.reportTypes.data;
       
        for(let key in types) {
            if(types.hasOwnProperty(key)) {
                if(types[key]){
                    let reportType = {
                        value: types[key]['id'],
                        label: types[key]['name']
                    }
                    reportTypes.push(reportType);
                }
            }
        }

        document.querySelector('title').innerHTML = 'MijnDP - Rapportage Generator';


        this.setState({
            reportTypes: reportTypes,
            user: this.props.user
        })

    }

    reportTypeSelected (value) {

        let reportTypeMetaCategories = this.props.reportTypes.data[value.value];
        this.setState({
            ...this.state,
            reportType: value,
            reportTypeMetaCategories : reportTypeMetaCategories
        });
    }

    getSelectedValue(categoryId) {
        if(this.state.attached_values[categoryId]) {
            return this.state.attached_values[categoryId]
        }
    }

    mapMetaSelectValues(valueObject, key) {
        return ({value: valueObject.id, label: valueObject.name})
    }

    setSelectedValue(value, categoryId) {
           // -- set local state
        this.setState({attached_values: {...this.state.selectedValues,[categoryId]:value}})
    }

    mapMetaTextValues(valueObject, key) {
        return (

                <label key={key}>
                    {valueObject.is_date === '1' ?
                         <DatePicker
                            dateFormat="DD-MM-YYYY"
                            shouldCloseOnSelect={true}
                            locale='nl-nl'
                            selected={
                                    this.state['date_'+key] ? this.state['date_'+key] :
                                            this.getTextValue(valueObject.id) !== null ?
                                            moment(this.getTextValue(valueObject.id) , "DD-MM-YYYY") :
                                        null
                                    }
                            data-categoryid={key}
                            onChange={(date) => this.handleDateChange(date, key)}
                            onBlur={(e) => this.setTextValue(e)} name={key}  />
                        :
                        <input type="text" data-categoryid={key} onChange={(e) => this.setTextValue(e)} name={key} />
                    }
                   &nbsp;{valueObject.name}
                </label>

        )
    }

    handleDateChange(date, key) {

        this.setState({['date_'+key]: date })
   }

    getTextValue(valueId, valueObject) {

        if(!this.state.attached_values)
                return null;

        if(this.state.attached_values[valueId+'_text']) {
            return this.state.attached_values[valueId+'_text']
        } else {
            return null;
        }
   }

   setTextValue(e) {

       this.setState({
            attached_values: {...this.state.attached_values,[e.target.name+'_text']: e.target.value}
        })
    }

    mapMetaCategories(categoryId, key) {
        const categoryObject = this.state.reportTypeMetaCategories[categoryId];
        if(categoryObject && categoryObject.values) {

            return (

                    <div className="report__row" key={key}>
                        <div className="table-style-header"><strong>{categoryObject.category}</strong></div>
                            {categoryObject.is_text === 1 ? categoryObject.values.map((value, key) => this.mapMetaTextValues(value, categoryId))
                            :
                                <Select

                                simpleValue={true}
                                onChange={value => this.setSelectedValue(value, categoryId)}
                                value={this.getSelectedValue(categoryId)}
                                multi={categoryObject.is_unique === "1" ? false : true}
                                options={categoryObject.values.map((value, key) => this.mapMetaSelectValues(value, categoryId))}
                                />

                            }
                    </div>


            )
        }
    }



    _getAddressesForReportTypes() {

        let selectableAddressess = [];
        for(let i in this.props.addresses) {
            if(this.props.addresses.hasOwnProperty(i)) {
                if(this.props.addresses[i]) {
                    let address = this.props.addresses[i];
                    let addressReportTypes = address.reportTypes;
                    //let result = addressReportTypes.find( this.state.reportType );

                    if(addressReportTypes.includes(this.state.reportType.value)) {
                        let value = {
                            value: address.dp_address_id,
                            label: address.street
                        }

                        selectableAddressess.push(value);
                    }

                }
            }
        }

        return(
             <div className="report__row" >
                <div className="table-style-header"><strong>Selecteer adres(sen)</strong></div>
                    <Select
                        closeOnSelect={true}
                        disabled={false}
                        multi={true}
                        allowSelectAll={selectableAddressess.length > 1 ? true : false}
                        allOption={{label: 'Alle adressen', value: 'all'}}
                        onChange={this.addressSelected}
                        options={selectableAddressess}
                        placeholder="Adressen"
                        removeSelected={this.state.removeSelectedAddress}
                        value={this.state.selectedAddresses}
                    />
            </div>
        )
    }

    addressSelected (value) {

        this.setState({
            ...this.state,
            selectedAddresses: value,
        });
    }
    _setSelectedRepetitive(value) {
        this.setState({selectedRepetitive: value})
    }

    _handleSubmit() {

        if(this.state.selectedAddresses) {
            const reportType = this.props.reportTypes.data[this.state.reportType.value];

           const filteredFiles = this.state.selectedAddresses.map((address) =>
               filterByValuesMessages(this.props.addresses.find( addressValue => addressValue.dp_address_id === address.value).files, this.state.attached_values, reportType.file_type_id)
           );


           if(!filteredFiles[0])
           {
                this.props.setSnackbarMessage("Uw selectie heeft geen resultaten opgeleverd");
           }
           else
           {
                this.props.addReport(this.props.clientPath + '/api/reports/action/add/', this.state, filteredFiles);
           }

        }

    }


    render() {

        return (
            <div className="column column--6">
                <div className="card" >

                    <div className="card__header">
                        <h1>Verzamelberichten</h1>
                    </div>

                    <div className="card__body">
                        <div className="card__content">
                        <p>Bepaal hier exact welke verzamelde berichten u eenmalig of periodiek  als een overzicht wilt ontvangen. </p>
                        <div className="report__row" style={{marginTop: 0}}>
                            <Select
                                autoFocus={true}
                                openOnFocus={true}
                                closeOnSelect={true}
                                disabled={false}
                                onChange={this.reportTypeSelected}
                                options={this.state.reportTypes ? this.state.reportTypes : []}
                                placeholder="Kies rubriek"
                                removeSelected={this.state.removeSelected}
                                value={this.state.reportType}
                            />
                        </div>
                    </div>

                        {this.state.reportTypeMetaCategories ? this._getAddressesForReportTypes() : null }

                        {this.state.selectedAddresses ? this.state.reportTypeMetaCategories ? Object.keys(this.state.reportTypeMetaCategories).map((category, key) => this.mapMetaCategories(category, key)) : null : null}
                        {this.state.selectedAddresses ?
                         <div className="report__row" >
                            <div className="table-style-header"><strong>Periodiek</strong></div>
                                    <Select

                                    simpleValue={true}
                                    onChange={value => this._setSelectedRepetitive(value)}
                                    value={this.state.selectedRepetitive}
                                    multi={false}
                                    options={this.state.repetitive}
                                    />
                        </div>
                        : ''}

                        {this.state.selectedAddresses ? this.state.reportTypeMetaCategories ? <div className="floating__button floating__button--right"><RaisedButton onClick={() => this._handleSubmit()} label="Opvragen" primary={true} fullWidth={true}/></div> : null : null}



                    </div>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
  return {
    addresses: state.AddressReducer.addresses,
    reportTypes: state.reportReducer.reportTypes,
    user: state.UserReducer,
    clientPath: state.ClientPathReducer.clientPath
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      addReport: (url, reportData, files) => dispatch(addReport(url, reportData, files)),
      setSnackbarMessage: (message) => dispatch(setSnackbarMessage(message))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportGenerator));



// WEBPACK FOOTER //
// ./src/components/Reports/Generator/index.js